import { CrmSalesStatus } from './types';

export const crmSalesStatuses: CrmSalesStatus[] = [
  'Lead',
  'Engage',
  'Warm',
  'Prospect',
  'Close Deal',
  'Lost'
];

export const crmSalesColumns = [
  {
    status: 'Lead',
    visibility: false,
    allowedPermissions: []
  },
  {
    status: 'Engage',
    visibility: false,
    allowedPermissions: []
  },
  {
    status: 'Warm',
    visibility: false,
    allowedPermissions: []
  },
  {
    status: 'Prospect',
    visibility: false,
    allowedPermissions: []
  },
  {
    status: 'Close Deal',
    visibility: false,
    allowedPermissions: []
  },
  {
    status: 'Lost',
    visibility: false,
    allowedPermissions: []
  }
];
